import { render, staticRenderFns } from "./iconWhatsapp.vue?vue&type=template&id=4a604237&scoped=true"
import script from "./iconWhatsapp.vue?vue&type=script&lang=js"
export * from "./iconWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a604237",
  null
  
)

export default component.exports